{% block sw_extension_listing_card %}
    <div class="sw-extension-listing-card" @click="openDetailPage">
        {% block sw_extension_listing_card_content %}
            {% block sw_extension_listing_card_preview %}
                <div class="sw-extension-listing-card__preview" :style="previewMedia">
                    {% block sw_extension_listing_card_preview_type_label %}
                        <sw-extension-type-label
                            :type="extension.type"
                            class="sw-extension-listing-card__extension-type-label"
                        />
                    {% endblock %}
                </div>
            {% endblock %}

            {% block sw_extension_listing_card_info_grid %}
                <div class="sw-extension-listing-card__info-grid">
                    {% block sw_extension_listing_card_info_name %}
                        <p class="sw-extension-listing-card__info-name">
                            {{ extension.label }}
                        </p>
                    {% endblock %}

                    {% block sw_extension_listing_card_info_description %}
                        <p class="sw-extension-listing-card__info-description is--wrap-content">
                            {{ extension.shortDescription }}
                        </p>
                    {% endblock %}

                    {% block sw_extension_listing_card_info_rating %}
                        <div class="sw-extension-listing-card__info-rating">
                            <sw-extension-rating-stars
                                class="sw-extension-listing-card__info-rating-stars"
                                :rating="extension.rating"
                                :size="12"
                            />

                            <span class="sw-extension-listing-card__info-rating-count">
                                {{ extension.numberOfRatings }}
                            </span>
                        </div>
                    {% endblock %}

                    {% block sw_extension_listing_card_info_price %}
                        <div class="sw-extension-listing-card__info-price">
                            <template v-if="isInstalled">
                                {{ $t('sw-extension-store.component.sw-extension-listing-card.labelInstalled') }}
                            </template>

                            <template v-else-if="isLicensed">
                                {{ $t('sw-extension-store.component.sw-extension-listing-card.labelLicensed') }}
                            </template>

                            <span v-else :class="discountClass">{{ calculatedPrice }}</span>
                        </div>
                    {% endblock %}

                    {% block sw_extension_listing_card_label_display %}
                        <sw-extension-store-label-display
                            v-if="extension.labels.length > 0"
                            :labels="extension.labels"
                            class="sw-extension-listing-card__label-display"
                        />
                    {% endblock %}
                </div>
            {% endblock %}
        {% endblock %}
    </div>
{% endblock %}
